import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { StyleGuideApproveInput, StyleGuideApprovePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = StyleGuideApproveInput;
type TData = StyleGuideApprovePayload;

export const useStyleGuideApprove = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation styleGuideApprove($input: StyleGuideApproveInput!) {
      styleGuideApprove(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
